module.exports = __webpack_public_path__ + "0639215e55d32f90597d3d02243e9dbb.svg";